import moment from 'moment';

type StyleArray = [string, unknown][];

export function toStyleVal(styles: StyleArray) {
  return styles.map(([k, v]) => `${k}:${v} !important;`).join('');
}

export function isNumeric(value: string) {
  return /^\d+$/.test(value);
}

export interface DataItem<TStore, TState> {
  name: string;
  store: DataStore<TStore>;
  disabled?: boolean;
  search: string;
  description: string[];
  state: TState;
}

export interface HeaderProps {
  text: string;
  align?: 'start' | 'center' | 'end' | 'none';
  sortable?: boolean;
  filterable?: boolean;
  groupable?: boolean;
  divider?: boolean;
  class?: string | string[];
  width?: string | number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filter?: (value: any, search: string, item: any) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sort?: (a: any, b: any) => number;
}

export type DataHeader<TData, THeader extends keyof TData = keyof TData> = {
  [P in keyof Pick<TData, THeader>]?: string | HeaderProps;
};

export type DataMorph<TData, THeader extends keyof TData = keyof TData> = {
  [P in keyof Pick<TData, THeader>]?: (item: never, idx: number, array: TData) => TData[P];
};

export abstract class BaseDataStore {}

export class DataStore<TData, THeader extends keyof TData = keyof TData> extends BaseDataStore {
  private _headers: DataHeader<TData, THeader>;
  private _items = [] as TData[];

  constructor(args: { headers: DataHeader<TData, THeader> }) {
    super();
    this._headers = args.headers;
  }

  get headers() {
    return Object.entries(this._headers).map(arr => {
      if (typeof arr[1] === 'string') {
        return { text: arr[1], value: arr[0] };
      } else {
        return { ...(arr[1] as object), value: arr[0] };
      }
    });
  }

  get items() {
    return this._items;
  }

  set items(items: TData[]) {
    this._items = items;
  }

  getHeaders() {
    return this._headers;
  }

  setHeaders(headers: DataHeader<TData, THeader>) {
    this._headers = headers;
  }

  getItems() {
    return this._items;
  }

  setItems(items: TData[]) {
    this._items = items;
  }
}

export function formatTime(time: string, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(time).format(format);
}
